import {ColumnsType} from 'antd/lib/table';
import IntlMessages from '../../../../../domain/utility/IntlMessages';
import {BsCheckLg, BsXLg} from 'react-icons/bs';
import {
  AiFillDelete,
  AiFillEdit,
  AiFillEnvironment,
} from 'react-icons/ai';
import {Dropdown, Menu} from 'antd';
import {popupConfirm} from '../../../../../shared/components/popup-confirm';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {useDeleteRegion} from '../../hooks/useDeleteRegion';
import {IRegionListData} from '../../../../../shared/services/configuration/countries/dtos/region-list';
import {
  setCountryRegionId,
  setRegionTableLoading,
} from '../../redux/countrySlice';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import RowActionsButton from 'src/shared/components/row-actions';

const TableColumns = (openDistrictsListModal: Function): ColumnsType<any> => {
  const {mutate, isLoading} = useDeleteRegion();
  const dispatch = useDispatch();
  const {messages} = useIntl();
  const {locale}: any = useLocaleContext();

  useEffect(() => {
    dispatch(setRegionTableLoading(isLoading));
  }, [isLoading]);

  const deleteRegion = (region: IRegionListData) => {
    popupConfirm(
      () => mutate(region?.Id),
      `${messages['commom.areYouSureYouWantToDelete'].toString()}` +
        ' ' +
        [
          region?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? region?.Name,
        ] +
        `?`,
    );
  };

  return [
    {
      title: <IntlMessages id='common.name' />,
      dataIndex: 'Name',
      key: 'Name',
      render: (value: string, record: IRegionListData) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: <IntlMessages id='countries.Published' />,
      render: (value) =>
        value ? <BsCheckLg color='green' /> : <BsXLg color='red' />,
      dataIndex: 'Published',
      key: 'Published',
      className: 'col-center',
    },
    {
      title: <IntlMessages id='category.categoryDelete' />,
      render: (text: string, record: IRegionListData) => (
        <div>
          <Dropdown
            trigger={['click']}
            overlay={() => (
              <Menu>
                <Menu.Item
                  key={'edit'}
                  onClick={() => dispatch(setCountryRegionId(record.Id))}>
                  <AiFillEdit className='icon-in-action' />
                  <span className='margin-in-action'>
                    <IntlMessages id='category.categoryEdit' />
                  </span>
                </Menu.Item>
                <Menu.Item
                  onClick={() => openDistrictsListModal(record.Id)}
                  key={'show'}>
                  <AiFillEnvironment className='icon-in-action' />
                  <span className='margin-in-action'>
                    <IntlMessages id='countries.region.showDistricts' />
                  </span>
                </Menu.Item>
                <Menu.Item onClick={() => deleteRegion(record)} key={'delete'}>
                  <AiFillDelete className='icon-in-action' />
                  <span className='margin-in-action'>
                    <IntlMessages id='category.categoryDelete' />
                  </span>
                </Menu.Item>
              </Menu>
            )}
            placement='bottomRight'>
            <RowActionsButton />
          </Dropdown>
        </div>
      ),
      className: 'col-actions',
      width: 80,
    },
  ];
};

export default TableColumns;
